/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { LoadingBarService } from '../services/loading-bar.service';

@Injectable()
export class LoadingBarInterceptor implements HttpInterceptor {
  private openRequests = new Map();

  constructor(private loadingBarService: LoadingBarService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // start our loader here
    this.showLoading(req.url);

    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
          // if the event is for http response
          if (event instanceof HttpResponse) {
            this.hideLoading(event.url);
          }
        },
        (err: any) => {
          // if any error (not for just HttpResponse) we stop our loader bar
          this.hideLoading(req.url);
        }
      )
    );
  }

  private hideLoading(url: string) {
    this.openRequests.delete(url);
    if (this.openRequests.size === 0) {
      this.loadingBarService.hide();
    }
  }

  private showLoading(url: string) {
    if (url && url.includes(environment.apiHostname)) {
      this.openRequests.set(url, 1);
      this.loadingBarService.show();
    }
  }
}
